import { render, staticRenderFns } from "./CategorySettingsBlock.vue?vue&type=template&id=b1a14d60&scoped=true&"
import script from "./CategorySettingsBlock.vue?vue&type=script&lang=js&"
export * from "./CategorySettingsBlock.vue?vue&type=script&lang=js&"
import style0 from "./CategorySettingsBlock.vue?vue&type=style&index=0&id=b1a14d60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a14d60",
  null
  
)

export default component.exports